import { DetailsPanelSource } from "PFApp/booking/components/details_panel";
import {
  BookingDetailSidePanelProfile
  // eslint-disable-next-line max-len
} from "PFApp/booking/parts/overview/detail_view/booking_detail/booking_detail_side_panel_context/booking_detail_side_panel_context.types";
import { BookingCategory } from "PFTypes";

import { Requirement } from "./requirement_selector";
import { OnSuccessData } from "./use_handle_submit/use_handle_submit";

export enum BookingFormMode {
  Create = "create",
  EditAll = "editAll",
  EditSingle = "editSingle",
  CloneSingle = "cloneSingle",
  CloneAll = "cloneAll"
}

export type BookingFormDataCreateMode = {
  profileId?: number;
  activityId?: number;
  shortlistId?: number;
  bookingCategoryId?: number;
  groupBookingData?: {
    searchId: number;
    total: number;
  };
  bookings?: { startDate: string; endDate: string }[];
  isProfileMatched?: boolean;
};

export type BookingFormDataEditOrCloneMode = {
  bookingId: number;
  suspendedProfileDetails?: BookingDetailSidePanelProfile;
};

export type BookingFormData = BookingFormDataCreateMode | BookingFormDataEditOrCloneMode;

export type BookingFormPropsData = {
  onSuccess?: (data?: OnSuccessData) => Promise<void> | void;
  customPreSubmitAction?: (shortlistId?: number, bookings?: BookingDataItem[]) => Promise<any>;
  mode?: BookingFormMode;
  source?: DetailsPanelSource;
};

export type BookingFormDetailsPanelData = {
  data?: BookingFormData;
  props?: BookingFormPropsData;
};

export enum BookingDataItemLimitation {
  None = "none",
  Readonly = "readonly",
  ReadonlyDifferentContext = "readonlyDifferentContext",
  Hidden = "hidden"
}

export type RepeatDaysData = {
  selectedWeekDays: number[];
  allowedWeekDays: number[];
};

export type BookingDataItem = {
  key: string;
  startDate: string;
  endDate: string;
  requirement: Requirement;
  limitation: BookingDataItemLimitation;
} & Partial<{
  id: number;
  bookingTemplateId: number;
  phaseSourceId: string | undefined;
  startTime: string;
  endTime: string;
  withTime: boolean;
  repeatDays: RepeatDaysData | undefined;
  overridesDiaryTime: boolean;
  overridesNonWorkingTime: boolean;
  category?: BookingCategory | null;
  title: string;
  description: string;
}>;
